module.exports = __webpack_public_path__ + "img/Huan Zhang.147369f6.jpg";